import React, { useState } from "react";

const Screen4 = ({ setFormData, formData }) => {
  const [radioCheck, setRadioChecked] = useState();

  const ignoreDupRecords = (val) => {
    setRadioChecked(val);
    setFormData({ ...formData, ignore_duplicate_record: true });
  };
  const updateDupRecords = (val) => {
    setRadioChecked(val);
    setFormData({ ...formData, ignore_duplicate_record: false });
  };
  return (
    <div className="screenfour d-flex flex-column">
      <h5 className="text-center fw-bold">[##] Duplicate Records Found </h5>
      <hr />
      <div
        className="mt-3 d-inline-flex align-items-center row-gap-2"
        onClick={() => updateDupRecords(1)}
        style={{ cursor: "pointer" }}
      >
        <span
          className={radioCheck === 1 ? "customradio active" : "customradio"}
        />
        <p className="m-0">Ignore duplicate records</p>
      </div>
      <div
        className="mt-3 d-inline-flex align-items-center row-gap-2"
        onClick={() => updateDupRecords(2)}
        style={{ cursor: "pointer" }}
      >
        <span
          className={radioCheck === 2 ? "customradio active" : "customradio"}
        />
        <p className="m-0">Update fields in duplicate records</p>
      </div>
    </div>
  );
};

export default Screen4;
